import { create } from 'zustand';
import { toast } from 'sonner';
import { useNavigationStore } from './navigation.store';

interface EntitySettingsModalState {
  isOpen: boolean;
  entityId: string | null;

  openForSelectedEntity: () => void;
  close: () => void;
}

export const useEntitySettingsModalStore = create<EntitySettingsModalState>((set) => ({
  isOpen: false,
  entityId: null,

  openForSelectedEntity: () => {
    const { selectedEntityId } = useNavigationStore.getState();
    if (!selectedEntityId || selectedEntityId === 'all') {
      toast.error('Select a specific entity first.');
      return;
    }
    set({ isOpen: true, entityId: selectedEntityId });
  },

  close: () => set({ isOpen: false, entityId: null }),
}));


